export default __webpack_public_path__ + "stumbler.fcfd172c.svg";